import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";

export interface GetServiceDataDTO {
  id: number;
  user_id?: number;
}

export interface IServiceData {
  about: string;
  start: string;
  bonus_email: string;
  bonus_friend: string;
  rules_link: string;
  pd_link: string;
  link_rules: string;
  parking: string;
  validate_qr_before: string;
  ob_reply_day: string;
  ob_reply_night: string;
  ob_notify_period: string;
  ob_notify_count: string;
  ob_remind_period: string;
  ob_remind_count: string;
  ob_remind_after: string;
  parking_enabled: number;
  theme_image: string;
  welcome_home_text: string;
  welcome_bonus_text: string;
  registered_subtext: string;
  invite_text: string;
  visit_bonus: number;
  link_sport: string;
  link_classes: string;
  link_services: string;
  link_rental: string;
  link_kids: string;
  link_eco: string;
  status_period: string;
  period_unit: string;
  notify_period: string;
}

export const GetServiceDataApi = async (
  dto: GetServiceDataDTO,
): Promise<IServiceData> => {
  const { data } = await api.post<IServiceData>(
    API_ROUTES.SERVICE,
    qs.stringify({ ...defaultOptions(), ...dto }),
  );

  return data;
};
